// extracted by mini-css-extract-plugin
module.exports = {"carrousselContent":"CarrousselPictures_carrousselContent__1IARf","pictureDiv":"CarrousselPictures_pictureDiv__3PI17","picture":"CarrousselPictures_picture__3UJKj"};